// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__26fPm","balanceDisclaimer":"posDashboard_balanceDisclaimer__26JyD"};